import type { User as AuthUser } from "firebase/auth"

import MyInvitesManager from "../../components/Groups/MyInvitesManager"
import UnifiedGroupTable from "../../components/Groups/UnifiedGroupMembersManager"
import type { Group } from "../../groups/types"

const MembersTab: React.FC<{
  activeGroup: Group
  user: AuthUser
}> = ({ user, activeGroup }) => {
  return (
    <div>
      <UnifiedGroupTable group={activeGroup} />
      <MyInvitesManager user={user} />
    </div>
  )
}
export default MembersTab
